import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import ReplayTimelineRow from './ReplayTimelineRow';

/**
 * Vertical trip timeline. Renders an empty state, else a connected feed of
 * ReplayTimelineRow. Scrolls within the card's remaining height.
 *
 * memo'd: the host re-renders every playback frame, but the feed only changes
 * when `events`/`activeId` change (activeId flips at event boundaries, not per
 * frame), so the rows skip the per-frame churn.
 */
function ReplayTimeline({ events, activeId, onSelect }) {
  const { t } = useTranslation();
  if (!events.length) {
    return (
      <div className="text-[11px] text-slate-400 px-3.5 py-6 text-center">
        {t('replay.noEvents', 'No events to show')}
      </div>
    );
  }
  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-3 pb-3">
      {events.map((e, i) => (
        <ReplayTimelineRow
          key={e.id}
          event={e}
          active={e.id === activeId}
          onSelect={onSelect}
          isFirst={i === 0}
          isLast={i === events.length - 1}
        />
      ))}
    </div>
  );
}

export default memo(ReplayTimeline);
